// WS-1 — Canonical short-form product disclaimer (provisional; final
// legal wording is WS-11). Reused across analysis, portfolio, locked
// preview, homepage stock-specific cards, and PDF export.

export const WS1_DISCLAIMER_TEXT = (
  "Stockaily provides model-based financial research and information. " +
  "It is not personalised investment advice and does not consider your " +
  "individual circumstances. Estimates may be wrong. Investing involves " +
  "risk and you make your own decisions."
);

export const WS1_METHODOLOGY_HINT = (
  "Estimates are model-derived from public data as of the timestamp shown. " +
  "See methodology and assumptions for full detail."
);

export const WS1_PUBLIC_RESEARCH_META_KEYS = [
  "issuer_ticker", "publication_ts", "last_updated_ts",
  "methodology_source", "valuation_date", "data_ts",
  "conflicts_of_interest", "operator_identity",
  "content_nature", "risk_statement", "correction_status",
];
